import Hero from '../hero/Hero';

const Home = ({animes}) => {
  return (
    <Hero animes = {animes} />
  )
}

export default Home